import { Clock } from '@lifeomic/chromicons';
import { defineMessages, useIntl } from 'react-intl';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { Pill } from '@lifeomic/chroma-react/components/Pill';
import * as React from 'react';
import clsx from 'clsx';

const messages = defineMessages({
  hellip: {
    id: 'omicsExplorer.sequenceCounts.countOrStatus.hellip',
    defaultMessage: '…',
  },
  zero: {
    id: 'omicsExplorer.sequenceCounts.countOrStatus.zero',
    defaultMessage: '0',
  },
  bigNumber: {
    id: 'omicsExplorer.sequenceCounts.countOrStatus.bigNumber',
    defaultMessage: '999+',
  },
});

const useStyles = makeStyles(theme => ({
  root: {},
  label: {
    marginRight: theme.spacing(0.75),
    marginBottom: theme.spacing(0.5),
  },
  isNotSelectedBadge: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.black[500],
  },
}));

interface CountOrStatusProps {
  label?: string;
  pillLabel?: number | string;
  isFetching?: boolean;
  isSelected?: boolean;
  isIndexing?: boolean;
}

export const CountOrStatus: React.FC<CountOrStatusProps> = ({
  label,
  pillLabel,
  isFetching = false,
  isSelected = false,
  isIndexing = false,
}) => {
  const classes = useStyles({});

  const { formatMessage } = useIntl();

  return (
    <>
      <span className={classes.label}>{label}</span>
      {isIndexing ? (
        <Clock role="presentation" width={18} height={18} />
      ) : (
        <Pill
          className={clsx(!isSelected && classes.isNotSelectedBadge)}
          color={isSelected ? 'primary' : 'default'}
          label={
            isFetching
              ? formatMessage(messages.hellip)
              : typeof pillLabel === 'number' && pillLabel > 999
              ? formatMessage(messages.bigNumber)
              : typeof pillLabel === 'number' && pillLabel > 0
              ? String(pillLabel)
              : formatMessage(messages.zero)
          }
        />
      )}
    </>
  );
};
